import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  hidden: {
    visibility: 'hidden',
  },
  tieringHeader: {
    margin: '3px 0',
  },
  tieringMetaData: {
    display: 'flex',
    justifyContent: 'space-between',
    div: {
      flex: 1,
      width: '33%',
    },
  },
  tieringInterval: {
    margin: '15px 0',
  },
  intervalList: {
    selectors: {
      '& .ms-DetailsHeader': {
        borderBottom: 0,
        lineHeight: pxToRem(30),
        height: pxToRem(30),
        display: 'flex',
        justifyContent: 'space-between',
      },
      '& .ms-DetailsHeader .ms-DetailsHeader-cell:hover': {
        backgroundColor: 'inherit',
      },
      '& .ms-DetailsRow': {
        borderBottom: 0,
        cursor: 'inherit',
        width: '100%',
      },
      '& .ms-DetailsRow:hover': {
        backgroundColor: 'inherit',
      },
      '& .ms-DetailsRow .ms-DetailsRow-fields': {
        width: '100%',
        justifyContent: 'space-between',
      },
      '& .ms-DetailsHeader .ms-DetailsHeader-cell .ms-DetailsHeader-cellTitle': {
        paddingRight: '3px',
        justifyContent: 'right',
        height: pxToRem(30),
      },
      '& .ms-DetailsRow .ms-DetailsRow-fields .ms-DetailsRow-cell': {
        padding: '0.3rem 3px 0.3rem 0',
        justifyContent: 'right',
      },
      '& .ms-DetailsHeader .ms-DetailsHeader-cell, & .ms-DetailsRow .ms-DetailsRow-fields .ms-DetailsRow-cell':
        {
          width: '140px !important',
        },
      '& .ms-DetailsHeader .ms-DetailsHeader-cell:first-child, & .ms-DetailsRow .ms-DetailsRow-fields .ms-DetailsRow-cell:first-child':
        {
          width: '45px !important',
        },
    },
  },
});
